import Vue from "vue"


Vue.filter('formatMoney', function (num) {

    var sNumOut = ''
    var sNumIn  = ''  
    var decimal = false
    var negativo = false
    
    if (num != undefined)
    {
      sNumIn  = num.toString()  
    } 

    if (sNumIn.length > 0)
    {
      if (sNumIn.charAt(0) == '-')
      {
        sNumIn = sNumIn.substr(1)
        negativo = true
      }

      if (sNumIn.indexOf(".") != -1)
      {
        decimal = true
        var vNum = sNumIn.split('.')
        sNumIn = vNum[0]
      }

      var i 
      var j = 0
      sNumIn = sNumIn.split('').reverse().join('') 

      for(i=0;i<sNumIn.length;i++)
      {
        j++
        sNumOut = sNumOut + sNumIn.charAt(i)
        if (j == 3)
        {
          sNumOut = sNumOut + '.'
          j=0 
        }
      }

      sNumOut = sNumOut.split('').reverse().join('') 

      if (sNumOut.charAt(0) == '.')
      {
        sNumOut = sNumOut.substr(1)
      }

      if (decimal && vNum.length > 1)
      {
        if (vNum[1].length == 1)
        {
          sNumOut = sNumOut+','+vNum[1]+'0'  
        }
        else
        {
          sNumOut = sNumOut+','+vNum[1].substring(0,2)  
        }
      }
      else
      {
        sNumOut = sNumOut+',00'  
      }
      if (negativo)
      {
        return '-'+sNumOut
      }
      else
      {
        return sNumOut
      }

    } 
    else
    {
      return ' '  
    }




})


// WEBPACK FOOTER //
// ./src/helpers/filters.js